export const R = {
  id: 0,
  name: "00. آموزش  مقدماتی زبان R",
  describe: "دارای 4 جلسه است",
  lectures: [
    {
      title: "جلسه اول",
      streamLink:
        "https://www.aparat.com/video/video/embed/videohash/Mgcrv/vt/frame",
      file: "",
      description: "آموزش مقدماتی R_ قسمت اول",
    },
    {
      title: "جلسه دوم",
      streamLink:
        "https://www.aparat.com/video/video/embed/videohash/dswKh/vt/frame",
      file: "https://openbookshelf.github.io/ProbStat/lectures/1/Lecture2.html",
      description: "آموزش مقدماتی R_ قسمت دوم",
    },
    {
      title: "جلسه سوم",
      streamLink:
        "https://www.aparat.com/video/video/embed/videohash/ZsD1e/vt/frame",
      file: "https://openbookshelf.github.io/ProbStat/lectures/1/Lecture3.html",
      description: "آموزش مقدماتی R_ قسمت سوم",
    },
    {
      title: "جلسه چهارم",
      streamLink:
        "https://www.aparat.com/video/video/embed/videohash/DjopA/vt/frame",
      file: "https://openbookshelf.github.io/ProbStat/lectures/1/Lecture4.html",
      description: "آموزش مقدماتی R_ قسمت چهارم",
    },
  ],
};
